import moment, { Moment } from "moment";

const DEFAULT_FORMAT = "yyyy-MM-DD";

const localMomentDate = (source: Moment, format = DEFAULT_FORMAT): Moment => {
   const result = moment(source);
   result.toISOString = () => result.format(format);
   return result;
}

export default localMomentDate;